import { APP_HOME, APP_LOGIN } from './paths';
import { MENU_FORM_INTAKE, MENU_FORM_EVENT_DETAILS, MENU_FORM_PRODUCT_INFO, FORM_SUB_TITLE } from './translate_keys';

//Header
export const MENU_EXCLUSION_PATH = [APP_HOME, APP_LOGIN];

//Form Stages
export const FORM_INTAKE = 'INTAKE';
export const FORM_EVENT_DETAILS = 'EVENT_DETAILS';
export const FORM_PRODUCT_INFO = 'PRODUCT_INFO';
export const FORM_STAGES = [
  { code: FORM_INTAKE, title: MENU_FORM_INTAKE },
  { code: FORM_PRODUCT_INFO, title: MENU_FORM_PRODUCT_INFO, subtitle: FORM_SUB_TITLE },
  { code: FORM_EVENT_DETAILS, title: MENU_FORM_EVENT_DETAILS },
];

//Answers
export const ANSWER_YES = 'Yes';
export const ANSWER_NO = 'No';
export const ANSWER_DURING_THERAPY = 'During Therapy';
export const ANSWER_CONTACT_OTHER = 'Contact Other';
export const ANSWER_UNKNOWN = 'unknown';
export const QUESTION_ANSWER_UNKNOWN = 'Unknown';
export const ANSWER_OTHER = 'Other';
export const ANSWER_CONTACT_ADDITIONAL = 'Contact Additional Contact Person';
// export const ANSWER_OPTION_REPORTEROCCUPATIONOPTIONS_ASKED_UNKNOWN = 'asked unknown';
export const ASKED_UNKNOWN = 'asked unknown';
export const DURING_SETUP_PREPARATION_COMPOUNDING = 'During Setup/Preparation/Compounding';
export const MULTIPLE_STEPS = 'Multiple Steps';

//Roles
export const ROLE_PATIENT = 'Patient';
export const ROLE_CAREGIVER = 'Caregiver';
export const ROLE_EMPLOYEE = 'Vantive Employee';
export const ROLE_PROFESSIONAL = 'Healthcare Professional';
export const ROLE_DISTRIBUTOR = 'Distributor';
export const ROLE_OTHER = 'Other';



//Miscellaneous
export const DATE_FORMAT = 'dd-MMM-yyyy';
export const REGION = 'LATAM';
export const DRUG = 'drug';
export const BIOLOGIC_PRODUCT = 'biologic product';
export const FILE_NOT_ALLOWED = 'File of types (.exe, .scr, .vbs, .js, .xml, .docm, .xps, .iso, .img, .cmd, .bat, .php, .py, .ps1) are not allowed';
export const FILETYPE_EXCLUSION_LIST = ["exe", "scr", "vbs", "js", "xml", "docm", "xps", "iso", "img", "cmd", "bat", "php", "py", "ps1", "rar", "php5", "pht", "phtml", "shtml", "asa", "cer", "asax", "swf", "xap"];
export const FILE_EXCEEDS_LIMIT = 'The file you are attempting to attach exceeds the storage limit. Please compress or attach a different file.';
export const FIELD_LIMIT_EXCLUSION_LIST = ["required_treatment", "relevant_tests", "medical_history"];
export const TEXTAREA_FIELD_LIMIT_EXCLUSION_LIST = ["shipping_distribution_label_productcode", "shipping_distribution_label_product_lot", "carton_label_productcode", "carton_label_productlot", "internal_product_labelcode", "internal_product_labellot"];
export const UNKNOWN_LANGUAGE_LIST = ["unknown", "asked unknown", "unbekannt", "gefragt unbekannt","desconocido", "preguntado desconocido", "inconnu", "demandé mais inconnu", "sconosciuto", "chiesto ma sconosciuto", "不明", "不明な質問", "알수없음", "질문되었지만 알 수 없음", "onbekend", "gevraagd maar onbekend", "nieznane", "zapytano lecz odpowiedź nieznana", "desconhecido", "perguntado/desconhecido", "perguntou desconhecido", "ไม่ทราบ", "ผู้แจ้งไม่ทราบ", "bilinmiyor", "soruldu, bilinmiyor", "không biết", "đã hỏi nhưng không biết", "知 未知","询问后但未知", "未知", "已詢問但未知"];
export const LANGUAGE_PICKER_EXCLUSION = ["zh-TW", "zh-CN"];